import { toLowerCase } from 'apps/promo/helpers/utils';

export interface CountryCurrency {
    code: string;
}

export interface CountryInfo {
    name: string;
    synonym?: string;
    alias?: string;
    currencies?: CountryCurrency[];
    phonePrefix?: string;
    prefix?: string;
    phone_prefix?: string;
    favorite?: boolean;
    popularRank?: number;
    usageCount?: number;
}

export class CountrySearchService {
    static search<TCountry extends CountryInfo>(countries: TCountry[] | undefined, value: string | undefined): TCountry[] | undefined {
        if (!value) {
            return countries;
        }
        const term = value;
        const termLength = term.length;
        return countries?.filter((country) => {
            const byName = toLowerCase(country.name).includes(toLowerCase(term));
            const bySynonym = country.synonym ? toLowerCase(country.synonym).includes(toLowerCase(term)) : false;
            const byAlias = country.alias ? toLowerCase(country.alias).includes(toLowerCase(term)) : false;
            const byCurrencyCode = Array.isArray(country.currencies)
                ? country.currencies.some((currency) => toLowerCase(currency.code).includes(toLowerCase(term)))
                : false;
            const prefix = country.phonePrefix ?? country.prefix ?? country.phone_prefix;
            const byPrefix = prefix ? prefix.includes(String(term)) : false;
            const byLongTerms = byName || bySynonym || byCurrencyCode || byPrefix || byAlias;
            const byShotTerms = byName || byCurrencyCode || byPrefix || byAlias;
            return termLength === 1 ? byShotTerms : byLongTerms;
        });
    }
}

export class RecentCountriesService {
    static getCountriesArrays<TCountry extends CountryInfo>(
        countries: TCountry[] | undefined,
    ): {
        favoriteCountries?: TCountry[];
        suggestionsCountries?: TCountry[];
    } {
        const favoriteCountries = countries?.filter((c) => c.favorite);
        const suggestionsCountries = countries?.filter((c) => c.popularRank && c.popularRank !== 0);
        return {
            favoriteCountries,
            suggestionsCountries,
        };
    }

    static compareByUsageCount<TCountry extends CountryInfo>(a: TCountry, b: TCountry): number {
        const usageA = a.usageCount ?? 0;
        const usageB = b.usageCount ?? 0;
        if (usageA > usageB) {
            return -1;
        }
        if (usageA < usageB) {
            return 1;
        }
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    }

    static compareByPopularRank<TCountry extends CountryInfo>(a: TCountry, b: TCountry): number {
        return (a.popularRank ?? 0) - (b.popularRank ?? 0);
    }
}
